"use client";

import { usePathname } from "next/navigation";
import React from "react";

import { useTranslations } from "next-intl";

import { EnumModalName } from "@/enums/modal-state";
import IconShare from "@/icons/share.svg";
import { useModalStore } from "@/store/modal.store";
import { cn } from "@/utils/cn";

interface Props {
  className?: string;
  title?: string;
  label?: React.ReactNode;
}

export const Share: React.FC<Props> = ({ className, title, label }) => {
  const t = useTranslations();
  const pathname = usePathname();
  const { openModal } = useModalStore();

  const handleClick = () => {
    const link = `${window.location.origin}${pathname}`;

    openModal(EnumModalName.shareLink, {
      link,
      title: `${t("Share")} ${title}`,
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "flex items-center gap-2 text-[#323232] cursor-pointer",
        className,
      )}
    >
      <IconShare size={24} />
      {label || null}
    </button>
  );
};
